import { render, staticRenderFns } from "./bedrooms.vue?vue&type=template&id=c9e7b24a"
import script from "./bedrooms.vue?vue&type=script&lang=js"
export * from "./bedrooms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../legacy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports